
import { Component, Vue, Prop, Watch, Emit } from 'vue-property-decorator'
import NewSwiper from '@xt/www/components/newSwiper/index.vue'
import LazyImg from '@xt/www/components/lazyImg/index.vue'
import { Observer } from 'mobx-vue'
import type { CalligraphyLevel2JsonResp } from '@xt/client/utils/activities/types'

@Observer
@Component({
  components: {
    LazyImg,
    NewSwiper
  }
})
export default class CoursesContent extends Vue {
  @Prop({ required: true }) readonly dataSource!: CalligraphyLevel2JsonResp['coursesContent']

  current: string = 'zzsx'
  tabList: string[] = ['zzsx', 'rczm'] as const

  get picList() {
    return this.dataSource[this.current] ?? []
  }

  onSelect(t: string) {
    if (this.current === t) return
    this.current = t
  }

  created(): void {}

  mounted(): void {}

  updated(): void {}

  destroyed(): void {}
}
